import React from 'react'
import { subscribe } from 'react-contextual'
import { SearchFilter } from '../../../views/components'
import PropertiesProvider from '../PropertiesProvider'

const PropertiesSearchFilter = (props: any) => <SearchFilter {...props} />

export default subscribe([PropertiesProvider], ({ location, redirect, propertyFilters }: any) => ({
  pathname: location.pathname,
  redirect,
  filters: propertyFilters,
}))(PropertiesSearchFilter)
